import BaseService from "./Base"
import {get} from "lodash"
import {Settings} from "types/settings"

class OutcomeService extends BaseService {
    getAll = async (params = {}) => {
        const response = await this.post("/v1/settings/outcome-groups/list", params)
        return get(response, "data", {})
    }

    getDetails = async (params = {}) => {
        const response = await this.post("/v1/settings/outcome-groups/details", params)
        return get(response, "data.data", {})
    }

    create = async (params = {}) => {
        const response = await this.post("/v1/settings/outcome-groups/create", params)
        return get(response, "data.data", {})
    }

    update = async (params = {}) => {
        const response = await this.post("/v1/settings/outcome-groups/edit", params)
        return get(response, "data.data", {})
    }

    delete = async (params = {}) => {
        const response = await this.post("/v1/settings/outcome-groups/delete", params)
        return get(response, "data.data", {})
    }

    getWorkflowTriggerOutcomeItems = async (params: {
        filter?: {isActive?: boolean; subunitId?: number}
    }): Promise<Settings.WorkflowTriggerOutcomeItem[]> => {
        const response = await this.post("/v1/settings/outcome-groups/list-workflow-trigger-items", params)
        return get(response, "data.data", [])
    }
}

export default OutcomeService
